<template>
  <div
    id="projBidQuotationDetailProject"
    :class="project.quoteStatus=='6'?'zhong':''"
  >
    <div class="card-header">
      <div class="card-header-left ellipsis">{{project.projectName}}</div>
      <div class="card-header-right">
        <ebShare />
      </div>
    </div>
    <div class="card-body">
      <div class="card-body-left">
        <img
          v-if="project.projectImages"
          :src="project.projectImages"
          alt="项目图片"
        >
        <img
          v-if="!project.projectImages"
          :src="$ebConfig.imgPath+'img/project-default.jpg'"
          alt="项目图片"
        >
      </div>
      <div class="card-body-right">
        <div class="card-three-row">
          <div class="col-440-lw">
            <div class="col-left">供应商名称:</div>
            <div class="col-right">
              <el-tooltip
                :content="project.departName"
                placement="top"
              >
                <span class="col-right-content"> {{project.departName}}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="col-148">
            <div class="col-left">当前状态:</div>
            <div class="col-right">
              <span class="col-right-content">{{project.projectStatus | projBidStatus}}</span>
            </div>
          </div>
          <div class="col-218">
            <div class="col-left">发布时间:</div>
            <div class="col-right">
              <el-tooltip
                :content="project.startTime | dateFormatYMDH "
                placement="top"
              >
                <span class="col-right-content">{{project.startTime |dateFormatYMDH}}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="card-three-row">
          <div class="col-243-lw">
            <div class="col-left">供应商级别:</div>
            <div class="col-right">
              <span class="col-right-content"> {{project.companyLevel | companyLevel}}</span>
            </div>
          </div>
          <div class="col-197-lw">
            <div class="col-left">供应商编码:</div>
            <div class="col-right">
              <el-tooltip
                :content="project.supplierCode"
                placement="top"
              >
                <span class="col-right-content">{{project.supplierCode}}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="col-148">
            <div class="col-left">销售代表:</div>
            <div class="col-right">
              <img
                @click="userInfoDialog(project.supplierUserId)"
                class="header_img"
                v-if="project.supUserheadImg"
                :src="headImgSrc"
              >
              <img
                @click="userInfoDialog(project.supplierUserId)"
                class="header_img"
                v-if="!project.supUserheadImg"
                :src="$ebConfig.imgPath+'img/user-default.jpeg'"
              >
            </div>
          </div>
          <div class="col-218">
            <div class="col-left">报价时间:</div>
            <div class="col-right">
              <el-tooltip
                :content="project.quoteTime | dateFormatYMDH "
                placement="top"
              >
                <span class="col-right-content">{{project.quoteTime |dateFormatYMDH}}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="card-three-row">
          <div class="col-243-lw">
            <div class="col-left">项目预算:</div>
            <div class="col-right">
              <span class="col-right-content"> {{project.projectBudget | formatCurrency}}</span>
            </div>
          </div>
          <div class="col-197-lw">
            <div class="col-left">当前报价:</div>
            <div class="col-right">
              <el-tooltip
                :content="project.quoteMin |formatCurrency"
                placement="top"
              >
                <span class="col-right-content">{{project.quoteMin|formatCurrency}}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="col-148">
            <div class="col-left">当前排序:</div>
            <div class="col-right">
              <span class="col-right-content"> 第{{no}}名</span>
            </div>
          </div>
          <div class="col-218">
            <div class="col-left">选定时间:</div>
            <div class="col-right">
              <el-tooltip
                :content="project.chosenTime | dateFormatYMDH "
                placement="top"
              >
                <span class="col-right-content">{{project.chosenTime |dateFormatYMDH}}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ebShare from '@/components/common/share/eb-share';
import eventBus from '@/plugins/event-bus';
import { baseURL } from '@/plugins/axios';
export default {
  name: 'ProjBidQuotationDetailProject',
  props: {
    project: {},
    no: {
      default: ''
    }
  },
  components: {
    ebShare
  },
  methods: {
    userInfoDialog: function(userId) {
      eventBus.$emit('userInfoDialog', userId);
    }
  },
  computed: {
    headImgSrc: {
      cache: true,
      get: function() {
        return baseURL + this.project.supUserheadImg + '?time=' + Date.now();
      }
    }
  }
};
</script>
<style lang="less" scoped>
#projBidQuotationDetailProject {
  &.zhong {
    background: url('../../../../assets/img/zhong.png') no-repeat 55% 0;
  }
  .card-header {
    display: flex;
  }
  .card-header-left {
    width: 60%;
    height: 52px;
    display: flex;
    color: #060606;
    font-weight: 700;
    font-family: 'Microsoft YaHei';
    align-items: center;
  }
  .card-header-right {
    width: 40%;
    height: 52px;
    display: flex;
    align-items: center;
    line-height: 22px;
    justify-content: flex-end;
    padding-right: 3.3%;
  }
  .card-body {
    display: flex;
  }
  .card-body-left {
    height: 135px;
    width: 18.3%;
    display: flex;
    img {
      margin: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .card-body-right {
    width: 80.6%;
    padding-left: 1%;
  }
  .header_img {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    margin-top: 8px;
    cursor: pointer;
  }
}
</style>
